import { useIntl, defineMessages } from 'react-intl';
import { useLocation } from 'react-router-dom';

import { RichTextArticle } from 'design-comuni-plone-theme/components/ItaliaTheme/View';

import FolderCard from '../Common/FolderCard';

const PersonaApprofondimenti = () => {
  const intl = useIntl();
  const location = useLocation();
  const path = location.pathname;

  return (
    <RichTextArticle
      title={intl.formatMessage(messages.approfondimenti)}
      tag_id="approfondimenti"
    >
      <div className="container">
        <div className="row">
          <FolderCard
            url={`${path}/approfondimenti`}
            title={intl.formatMessage(messages.approfondimenti)}
          />
        </div>
      </div>
    </RichTextArticle>
  );
};

const messages = defineMessages({
  approfondimenti: {
    id: 'approfondimenti',
    defaultMessage: 'Approfondimenti',
  },
});

export default PersonaApprofondimenti;
